<template>
  <div class="app-main-content" type="primary">
    <div class="details-view">
      <div class="main-content">
        <div class="operations" style="margin-bottom: 5px;">
          <div style="display: flex">
            <div v-show="action==='look'">
              <el-button no="back" type="primary" class="can-operate" @click="goBack">{{ $t('common.btn.back') }}</el-button>
              <el-button
                v-if="$checkPermission(['button_cabinManagement_edit'])"
                no="edit"
                type="primary"
                @click="toEdit()"
              >{{ $t('common.btn.edit') }}
              </el-button>
              <el-button
                no="Clone"
                type="primary"
                @click="toClone()"
              >{{ $t('SeaExport.Clone') }}
              </el-button>
            </div>
            <div v-show="['edit', 'add'].includes(action)" class="btn-group-edit" style="border-left:none;">
              <el-button no="save" type="success" @click="saveHandler">{{ $t('common.btn.save') }}</el-button>
              <el-button no="cancel" type="success" @click="cancelEdit(()=>{againShow('look')})">{{ $t('common.btn.cancel') }}</el-button>
            </div>
            <div class="right-tip" style="padding-left: 20px;font-size:20px;color:red;width:200px;overflow:hidden;">
              <span>{{ allocationStatusLabel }}</span>
            </div>
          </div>
        </div>
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleTabClick">
            <el-tab-pane :label="$t('CargoMsg.Cargo_Basic')" name="tabBasic" :lazy="true">
              <tab-basic ref="tabBasic" :context="context" :action="action" />
            </el-tab-pane>
            <el-tab-pane v-if="action !== 'add'" name="tabFileHistory" :label="$t('SeaExport.FileHistory')" :lazy="true">
              <tab-file-history ref="tabFileHistory" :context="context" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory.vue'
import TabBasic from '@/views/cargo/v0/SeaExport/cabinManagement/tabBasic.vue'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider/index.vue'
import CargoIm from '@/components/Cargo/Common/CargoIm/index.vue'
import { loadCabinManagementFunc, saveCopyCabinFunc, saveFunc } from '@/api/booking/cabinManagement'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { TabError } from '@/utils/class/TabError'
import { CabinManagement } from '@/class/model/booking/CabinManagement'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { ALLOCATION_0, CABIN_0, CABIN_1, CABIN_2 } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'CabinDetail',
  components: { CargoIm, CargoButtonGroupSlider, TabBasic, tabFileHistory },
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeTabName: 'tabBasic',
      currentRow: {},
      copyNum: 0, // 复制次数
      note: '', // MBL or SO
      listType: 0, // 订舱状态
      fillType: 0, // 填充类型
      pendTabSet: new Set(),
      action: ''
    }
  },
  computed: {
    allocationStatusLabel() {
      if (this.currentRow) {
        return ColumnUtils.showTypeLabelFunc(this.currentRow.allocationStatus, SystemConstants.ALLOCATION_LIST) +
          ' ; ' + ColumnUtils.showTypeLabelFunc(this.currentRow.cabinSpaceStatus, SystemConstants.CABIN_LIST)
      }
      return ''
    }
  },
  methods: {
    async onShow(action, rowData, options) {
      this.action = action
      this.copyNum = 1
      this.currentRow = new CabinManagement().fillDefaultValue().getData()
      if (this.action !== 'add' && rowData && rowData.uuid) {
        await loadCabinManagementFunc({ uuid: rowData.uuid }).then(res => {
          this.currentRow = res.data
        })
      } else if (options && options.data) {
        // 复制场景
        this.currentRow = options.data
        this.copyNum = options.copyNum
        this.note = options.note
        this.listType = options.listType
        this.fillType = options.fillType
        this.activeTabName = 'tabBasic'
        this.currentRow.branchId = this.$store.getters.currentOfficeId
        this.currentRow.cargoType = 'GC'
        this.currentRow.allocationStatus = 0
        if (this.listType === 0) {
          this.currentRow.cabinSpaceStatus = CABIN_2.code
        } else {
          this.currentRow.cabinSpaceStatus = CABIN_1.code
        }
      } else if (this.action === 'add') {
        this.activeTabName = 'tabBasic'
        this.currentRow.cargoType = 'GC'
        this.currentRow.allocationStatus = ALLOCATION_0.code
        this.currentRow.cabinSpaceStatus = CABIN_0.code
        this.currentRow.branchId = this.$store.getters.currentOfficeId
      }
      this.handleTabClick()
    },
    handleTabClick() {
      this.pendTabSet.add(this.activeTabName)
      this.$nextTick(() => {
        this.$refs[this.activeTabName].onShow(this.currentRow, true)
      })
    },
    goBack() {
      this.$emit('back', this.currentRow)
    },
    async saveHandler() {
      const loading = getLoading4Cxt(this)
      const body = {}
      try {
        let tabData = {}
        const result = this.$refs['tabBasic'].getSubmitData()
        if (result instanceof Promise) {
          tabData = await result
        } else {
          tabData = result
        }
        Object.assign(body, tabData)
      } catch (err) {
        loading.close()
        if (err instanceof TabError) {
          this.activeTabName = err.tabName
          if (err.message) {
            this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
          }
          return
        }
        throw err
      }

      saveFunc(body).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        const result = res.data
        if (result) {
          this.currentRow = result
          this.action = 'look'
          this.handleTabClick()
          // 复制多份业务 保存的处理逻辑
          if (this.copyNum > 1 && this.currentRow.uuid) {
            this.saveCopyHandle(this.currentRow.uuid, this.copyNum - 1)
          }
        }
      }).catch((err) => {
        throw err
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    async saveCopyHandle(uuid, copyNum) {
      //
      const item = {}
      item.uuid = uuid
      item.branchId = this.$store.getters.currentOfficeId
      item.listType = this.listType
      item.fillType = this.fillType
      item.note = this.note
      item.copyNum = copyNum
      await saveCopyCabinFunc(item)
    },
    // 取消编辑
    cancelEdit(done) {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        if (typeof done === 'function') {
          done()
        }
      }).catch(() => {
      })
    },
    toEdit() {
      this.$emit('edit', this.currentRow)
    },
    toClone() {
      this.$emit('clone', this.currentRow)
    },
    againShow(action, row) {
      if (this.action === 'add') {
        this.action = action
        this.goBack()
      } else {
        this.onShow(action, this.currentRow)
      }
    }
  }
}
</script>
